import {createReducer, on} from '@ngrx/store';
import {MoveBelegDialogState} from '../states/move-beleg-dialog.state';
import {MoveBelegDialogActions} from '../actions/move-beleg-dialog.actions';

export const initialMoveBelegeDialogState: MoveBelegDialogState = {
  isOpen: false,
  sourceInhaberId: '',
  belegIds: [],
};

export const moveBelegDialogReducer = createReducer(
  initialMoveBelegeDialogState,

  on(MoveBelegDialogActions.open, (state, {sourceInhaberId, belegIds}) => ({
    ...state,
    isOpen: true,
    sourceInhaberId,
    belegIds,
  })),

  on(MoveBelegDialogActions.close, () => ({
    ...initialMoveBelegeDialogState,
  })),
);
